export default "__VITE_ASSET__Bg2m8YVg__"